import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Account, CreateAccountInput, UpdateAccountInput } from '@wave/shared';
import { api } from './client';

const KEY = ['ref', 'accounts'] as const;
const KEY_WITH_COUNTS = [...KEY, 'with-counts'] as const;

export function useChats() {
  return useQuery({
    queryKey: KEY_WITH_COUNTS,
    queryFn: () => api.get<Account[]>('/ref/accounts', { kind: 'all', includeCounts: 'true' }),
  });
}

export function useCreateChat() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateAccountInput) => api.post<Account>('/ref/accounts', input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateChat() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { code: string; patch: UpdateAccountInput }) =>
      api.patch<Account>(`/ref/accounts/${encodeURIComponent(vars.code)}`, vars.patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteChat() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (code: string) =>
      api.delete<{ ok: true; mode: 'hard' | 'soft' }>(`/ref/accounts/${encodeURIComponent(code)}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
